export default __webpack_public_path__ + "static/media/Camera.4289b905.svg";